module.exports = __webpack_public_path__ + "media/images/icons/question-circle-a56a63051d81f7374d01c859defa5f7b.svg";